import React from 'react';

import { useIsFocused } from '@react-navigation/native';
import { useStoreContext } from 'features/store';
import { freezeEnabled } from 'react-native-screens';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { LocationEmptyState } from 'components/location-empty-state';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { LoyaltyIncentiveCooldownMessage } from 'pages/loyalty/loyalty-incentives-components/loyalty-incentive-cooldown-message';
import { LoyaltyOffersBase } from 'pages/loyalty/loyalty-offers/loyalty-offers-base';
import { t } from 'state/intl/translations';
import { isWeb } from 'utils/environment';

export default function OffersScreen() {
  const { noStoreSelected } = useStoreContext();

  /**
   * IMPORTANT: Do not remove this code or offers will have issues in cart on web!
   *
   * Why this is needed:
   * - On web, components remain mounted when navigating between tabs (unlike native
   *   where they are "frozen" with react-native-screens).
   * - This means renders can occur here when on other pages only on web.
   * - The useReduceOffers hook (used nested here) has a side effect that causes the
   *   cart to not load properly if it's running simultaneously with the one in cart.
   *
   * The freezeEnabled check handles the case where screen freezing might be
   * disabled in the future, which would cause this bug to appear on native too.
   */
  if (isWeb || !freezeEnabled()) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isFocused = useIsFocused();
    if (!isFocused) {
      return null;
    }
  }

  if (noStoreSelected) {
    return <LocationEmptyState title={t('emptyOffersHeading')} message={t('emptyMenuMessage')} />;
  }

  return <OffersInner />;
}

const OffersInner = React.memo(() => {
  return (
    <>
      <LoyaltyOffersBase />
      <LoyaltyIncentiveCooldownMessage incentiveType={LoyaltyPromotionType.OFFER} />
      <FloatingViewCartFab />
    </>
  );
});
